import { useEffect, useRef } from "react";
import {
  SESSION_BROADCAST_CHANNEL,
  SESSION_BROADCAST_TYPE_FORCE_LOGOUT,
  SESSION_LOGOUT_REASON_REMOTE,
} from "../../utils/session.constants";
import { getSessionTabId, sessionLogout } from "../../utils/sessionLogout";

export function useSessionLogoutBroadcast(instance, account) {
  const accountRef = useRef(account);
  useEffect(() => {
    accountRef.current = account;
  }, [account]);

  useEffect(() => {
    if (typeof BroadcastChannel === "undefined") {
      return undefined;
    }

    let ch;
    try {
      ch = new BroadcastChannel(SESSION_BROADCAST_CHANNEL);
    } catch (e) {
      return undefined;
    }

    const handler = (event) => {
      const data = event && event.data;
      if (!data || data.type !== SESSION_BROADCAST_TYPE_FORCE_LOGOUT) {
        return;
      }
      if (data.tabId && data.tabId === getSessionTabId()) {
        return;
      }

      const acc = accountRef.current;
      if (!instance || !acc) {
        return;
      }
      sessionLogout(instance, acc, {
        reason: data.reason || SESSION_LOGOUT_REASON_REMOTE,
        broadcast: false,
      });
    };

    ch.addEventListener("message", handler);
    return () => {
      ch.removeEventListener("message", handler);
      ch.close();
    };
  }, [instance]);
}
